//Images: RocketFi
import disconnectIcon from './imgs/RocketDisconnect_icon.png';
import connectingIcon from './imgs/RocketConnecting_icon.png';
import connectedIcon from './imgs/Connected_icon.png';
import rocketfiIcon from './imgs/rocketfi_yellow_token.png';

import appMenuActive from './imgs/appMenuActive_icon.png'; // Icon to be used when hovering over icon2
import appMenuStandby from './imgs/appMenuStandby_icon.png'; // Icon to be used when connected
import appMenuPressed from './imgs/appMenuPressed_icon.png'; // Icon to be used when pressed

//Images: Floatie
import floatieDisconnectIcon from './imgs/FloatieDisconnect_icon.png';
import floatieConnectingIcon from './imgs/FloatieConnecting_icon.png';
import floatieConnectedIcon from './imgs/FloatieConnected_icon.png';
import floatieIcon from './imgs/floatie_pink_icon.png';
import floatieIconBW from './imgs/floatie_pink_icon_bw.png';

import appMenuActive_floatie from './imgs/appMenuActive_floatie_icon.png'; // Icon to be used when hovering over icon2
import appMenuStandby_floatie from './imgs/appMenuStandby_floatie_icon.png'; // Icon to be used when connected
import appMenuPressed_floatie from './imgs/appMenuPressed_floatie_icon.png'; // Icon to be used when pressed


//Images: Floatie
import ultraDisconnectIcon from './imgs/UltraDisconnect_icon.png';
import ultraConnectingIcon from './imgs/UltraConnecting_icon.png';
import ultraConnectedIcon from './imgs/UltraConnected_icon.png';
import ultraIcon from './imgs/ultrablue_color_icon.png';

import appMenuActive_ultra from './imgs/appMenuActive_ultra_icon.png'; // Icon to be used when hovering over icon2
import appMenuStandby_ultra from './imgs/appMenuStandby_ultra_icon.png'; // Icon to be used when connected
import appMenuPressed_ultra from './imgs/appMenuPressed_ultra_icon.png'; // Icon to be used when pressed

//Images: Radar
import radarIcon from './imgs/radar_blue_icon.png';

//Images: Refuel
import connectedIcon_refuel from './imgs/Connected_icon_refuel.png';
import refuelIcon from './imgs/refuel_color_icon.png';

import appMenuActive_refuel from './imgs/appMenuActive_refuel_icon.png'; // Icon to be used when hovering over icon2
import appMenuStandby_refuel from './imgs/appMenuStandby_refuel_icon.png'; // Icon to be used when connected
import appMenuPressed_refuel from './imgs/appMenuPressed_refuel_icon.png'; // Icon to be used when pressed

//Abi: RocketFi
import rewardPacksAbi from "./contracts/rewardPacksAbi";
import rewardPackManagerAbi from "./contracts/rewardPackManagerAbi";
import rewardPackOracleAbi from "./contracts/rewardPackOracleAbi";
import smartRewardsAbi from "./contracts/smartRewardsAbi";
import rocketFiOracleAbi from "./contracts/rocketFiOracleAbi";
import liquidityOracleAbi from "./contracts/liquidityOracleAbi";
import liquidityOraclePaginatorAbi from './contracts/liquidityOraclePaginatorAbi';
import liquidityOracleAbi2 from "./contracts/liquidityOracleAbi_2";
import rocketFuelAbi from "./contracts/rocketFuelAbi";
import rocketFiAbi from "./contracts/rocketFiAbi";
import burnToEarnResyncAbi from './contracts/burnToEarnResyncAbi';
import payItForwardAbi from './contracts/payItForwardAbi';
import rocketSwapperAbi from './contracts/rocketSwapperAbi';
import rocketSwapperLegacyAbi from './contracts/rocketSwapperLegacyAbi';
import smartRewards_V2_Pool_Abi from './contracts/smartRewards_V2_Pool_Abi';
import smartRewards_V2_Gateway_Abi from './contracts/smartRewards_V2_Gateway_Abi';
import smartCodesAbi from './contracts/smartCodesAbi';
import smartCodePositionOracleAbi from './contracts/smartCodePositionOracleAbi';
import smartCodeRewardShareSyncerAbi from './contracts/smartCodeRewardShareSyncerAbi';
import rocketFiRewardsAbi from './contracts/rocketFiRewardsAbi';
import loyaltyEngineAbi from './contracts/loyaltyEngineAbi';
import earningsTrackerAbi from './contracts/earningsTrackerAbi';
import earningsTracker_V1_Abi from './contracts/earningsTracker_V1_Abi';
import rocketPlayAbi from './contracts/rocketPlayAbi';
import resyncSharesAbi from './contracts/resyncSharesAbi';
import rocketFiFeeRouterAbi from './contracts/rocketFiFeeRouterAbi';

//Abi: Refuel
import ierc20Abi from './contracts/ierc20Abi';
import refuelDepositerAbi from './contracts/refuelDepositerAbi';
import refuelRewardsAbi from './contracts/refuelRewardsAbi';

//Abi: Radar
import dividendToken_1_Abi from "./contracts/dividendToken_1_Abi"
import dividendToken_2_Abi from "./contracts/dividendToken_2_Abi"
import distributorToken_1_Abi from "./contracts/distributorToken_1_Abi"
import yinyangAbi from "./contracts/yinyangAbi"
import reflectrAbi from "./contracts/reflectrAbi"
import ausdAbi from "./contracts/ausdAbi"
import atronAbi from './contracts/atronAbi';
import liquidityPricingCalculatorAbi from './contracts/liquidityPricingCalculatorAbi';
import lpSeederAbi from './contracts/lpSeederAbi';

//Abi: Ultra
import feeHookAbi from './contracts/feeHookAbi';
import ultraDistributorAbi from './contracts/ultraDistributorAbi';

//Abi: Floatie
import lockerBayAbi from './contracts/lockerBayAbi';
import lockerAbi from './contracts/lockerAbi';
import votingProposalAbi from './contracts/votingProposalAbi';
import floatieGatewayAbi from './contracts/floatieGatewayAbi';
import floatieGatewayOracleAbi from './contracts/floatieGatewayOracleAbi';
import floatieBurnAbi from './contracts/floatieBurnAbi';
import floatieEarnAbi from './contracts/floatieEarnAbi';
import floatiePlayAbi from './contracts/floatiePlayAbi';
import floatieStakeAbi from './contracts/floatieStakeAbi';

//distributors
import dividendToken_1_distributorAbi from "./contracts/dividendToken_1_distributorAbi";
import distributor_1_Abi from "./contracts/distributor_1_Abi";


//Contracts: RocketFi
const RP_ROCKETFI_FEE_ROUTER_CONTRACT_ADDRESS = "0xE592B80eB31B5023928E5C8ca5f976A2692fbA1a";
const RP_RESYNC_SHARES_CONTRACT_ADDRESS = "0x0369AD888156C76c49aF2f95F367256c08a54736";
const RP_REWARD_PACKS_CONTRACT_ADDRESS = "0xf7c45F92d18D80fab5ECEa7899bb5b5e3c82B4a7";
const RP_REWARD_PACKS_ORACLE_CONTRACT_ADDRESS = "0x4984DC277F326EB273892e65eF16589a0c7914D6"; // Paginated version
const RP_REWARD_PACK_MANAGER_CONTRACT_ADDRESS = "0xE78DE19102295ee9Be2678cEFF911FE61929c7A7";
const SMART_REWARDS_CONTRACT_ADDRESS = "0xB6D50C98bD20D1b4ED6bdE6BeB9e8a19e3845D9c";
const SMART_REWARDS_V2_CONTRACT_ADDRESS = "0x56e6f8F6e22B7fe9a2a0EaeD37e3579C786dde31";
const SMART_REWARDS_V1_CONTRACT_ADDRESS = "0x4543fdF225D7E567D3b5339eb4631d552128C746";
const RP_ROCKETFI_ORACLE_CONTRACT_ADDRESS = "0x6cB2F1Ec30efd50bDAe49452B213b44B19b8c083";
const ROCKETFI_ORACLE_CONTRACT_ADDRESS = "0xdff8212f19A18e5E37ed76Be40d28f8Fe6a1526E";
const ROCKETFI_ORACLE_V2_CONTRACT_ADDRESS = "0xeD633d3A430bC9dc2f775f29Dc13101466B06394";
const ROCKETFI_ORACLE_V1_CONTRACT_ADDRESS = "0x1E2ad5F51B8a4965aD5b99040c2C6099aA7a711E";
const LIQUIDITY_ORACLE_CONTRACT_ADDRESS = "0x7efbaC2600E38698d5ca6aC8E726426B073b65d1"; //New 
const LIQUIDITY_ORACLE_PAGINATOR_CONTRACT_ADDRESS = "0x695a1487B38ffB5f0145904e2097Ea4697dd2309"; // Paginated version
//const LIQUIDITY_ORACLE_PAGINATOR_CONTRACT_ADDRESS = "0x2D2aB5A3EfA80dAA24978935518575DDa0F372f1";
//const LIQUIDITY_ORACLE_CONTRACT_ADDRESS = "0x3e9a47727F70208cf53b513118A6938891aac46f"; //old production
//const LIQUIDITY_ORACLE_CONTRACT_ADDRESS = "0xeB5b3026152C0D12D57f65D1acedf70c966A38B0";
const ROCKET_FUEL_CONTRACT_ADDRESS = "0xeB6Aa1466259aeDa40d56841F00ABcE33799188F";
const ROCKETFI_CONTRACT_ADDRESS = "0x6e61579c22F9a6dA63a33e819f29B6697d2a126E";
const BURN_TO_EARN_RESYNC_CONTRACT_ADDRESS = "0x505d965495fd8C3637376a07c220863AfbD1e135";
const PAY_IT_FORWARD_CONTRACT_ADDRESS = "0xF6083fCa135Ba5fA1aFab5987b18b9a9D490C360";
const ROCKET_SWAPPER_CONTRACT_ADDRESS = "0x50621cBB5e9093319FEa80a96653A8cDea7E334c";
const ROCKET_SWAPPER_LEGACY_CONTRACT_ADDRESS = "0xEF09d18e7fc101B3d6985Fe7b0277B7DF5db450A";
const SMART_CODES_V1_CONTRACT_ADDRESS = "0x39BFCdC1E10a28C8C369E4b7996c082791E5a33c";
const SMART_CODES_CONTRACT_ADDRESS = "0x3222cb5741588461C1aC0dB60452F1D06f285a2e";
const SMART_CODES_POSITION_ORACLE_CONTRACT_ADDRESS = "0xBF1624e93aeD8c9aD8407868260D6f639b27365b";
const SMART_CODES_REWARD_SHARE_SYNCER_CONTRACT_ADDRESS = "0x6C44FdC9A76535e319Fe3f60A161cE3a5014ea57";
const ROCKETFI_REWARDS_CONTRACT_ADDRESS = "0x0aD6faF75c08e3e73D9702e8F45E725171aa34b3";
const LOYALTY_ENGINE_CONTRACT_ADDRESS = "0xd9fbd6C88B1Bfcc5cff11641baC4f53500DeEe91";
const EARNINGS_TRACKER_V1_CONTRACT_ADDRESS = "0xEb259eD6711397AC59F2d23F8680a8e3b3C5f4c8";
const EARNINGS_TRACKER_CONTRACT_ADDRESS = "0x24F5dc07E921A0966d6A154CB255B7277477Db23";
const ROCKETPLAY_CONTRACT_ADDRESS = "0x11D76e783CFA21bda454B2d20Efcf20D4DA5B9EF";

const LEGACY_CONFIG = {
    //Smart Rewards V2
    "0x56e6f8F6e22B7fe9a2a0EaeD37e3579C786dde31": {
        abi: smartRewards_V2_Pool_Abi,
    },
    //Smart Rewards V1
    "0x4543fdF225D7E567D3b5339eb4631d552128C746": {
        abi: smartRewards_V2_Pool_Abi,
    },
}

//Contracts: Ultra
const FEEHOOK_CONTRACT_ADDRESS = "0xF706e331Fd260944E5DBA81E95Ef04819447eE7d";
const ULTRA_DISTRIBUTOR_CONTRACT_ADDRESS = "0xd7EF680B80F0355dAD2EEd65DD3c978515836081";

//Contracts: Floatie
const LOCKERBAY_CONTRACT_ADDRESS = "0x6111a3757DD9E18A46ebbf13a8034D5D4eb5e6b1";
const VOTING_PROPOSAL_CONTRACT_ADDRESS = "0xd1867fb59370e38EB5575996f5E05dEEb92e5D88";
const FLOATIE_GATEWAY_CONTRACT_ADDRESS = "0xceACd5C25F20E92B058c5E4A91EF6774f4b82395";
const FLOATIE_GATEWAY_ORACLE_CONTRACT_ADDRESS = "0x4209be74c82EAb14e29cBF7032E02a9121E9F6E5";
const FLOATIE_BURN_CONTRACT_ADDRESS = "0x74B3cF72de069cc3e8E9eB7B8aD2576C6e413763";
const FLOATIE_EARN_CONTRACT_ADDRESS = "0x7e44943939EE086a5B270aE9ef56229e92829dB1";
const FLOATIE_PLAY_CONTRACT_ADDRESS = "0x7e401C8f3e98Bde1a6eAa1943f20fB809AF1fe97";
const FLOATIE_STAKE_CONTRACT_ADDRESS = "0xe9Affc927DaD2f0a18f5a8B3Eb70ba5394F914BF";

//Contracts: ReFuel
const REFUEL_DEPOSITER_CONTRACT_ADDRESS = "0x43cA770f6fBF073064926B6570554A188359E997";
const REFUEL_REWARDS_CONTRACT_ADDRESS = "0x3E187Eef5322821C733c1C8525e00a08239996Fc";



//Contracts: Radar
const YIN_CONTRACT_ADDRESS = "0x5d5dC8e4D680FC3eF33986292eB02315ab05c735";
const YANG_CONTRACT_ADDRESS = "0xC486312D5158315C7Bbe2C353ad565d1A9d1f0de";
const REFLECTR_CONTRACT_ADDRESS = "0x5097FccD1E58fC18717c6bFc8Ca0E6dc0e006758";
const AUSD_CONTRACT_ADDRESS = "0x27874A586bafaF54d4Cd0aae368ad9569D06d115";
const ATRON_CONTRACT_ADDRESS = "0xA11b53C5ecA5AFcb9eB8e7E60260721c4f398279";
const LIQUIDITY_PRICING_CALCULATOR_CONTRACT_ADDRESS = "0x486340A5485f264d316f8bFA33fd3ec351E883C2";
const LP_SEEDER_CONTRACT_ADDRESS = "0x753ebB494A4f74A43B76614AF0F8a8719cE9fECE";//"0x2aA2A98f8b98F0bF1205bEBE0d763e040f654D4a";//"0xb5C137510F1a4690043A995B41609241041Dd7AE";//"0x03d3441EdD5660ff26ca1e34A6EdfF97aa327F3e";

const ALL_TOKENS = [
    "0x5097FccD1E58fC18717c6bFc8Ca0E6dc0e006758", //ReflectR
    "0x5d5dC8e4D680FC3eF33986292eB02315ab05c735", //Yin
    "0xC486312D5158315C7Bbe2C353ad565d1A9d1f0de", //Yang
    "0x942e4B2De5BA499181b390daD4CAe8e0A27c606b", //AutoBTC
    "0xa68D77D85b24257adae0bC9Ca96edcBCba5F03Ea", //OBS
    "0x651a89fed302227d41425235F8E934502FB94C48", //ADACash
    "0x7B86f5ca09Dc00502E342b0FeF5117E1c32222Ce", //SolCash
    "0x3C2e501B08CF5C16061468c96b19b32bae451dA3", //EverFlect
    "0x3a91A88Ef4bB813BB99EF5a745bcb56e3A3b403b", //INCOME
    //"0xA7efd5D0575cD4682B0c83155bB9e4Ff1a85a6F9", //LMG
    "0xA341E745078035D6d19E2F2B518DE31f29b2a1bE", //RDFY
    "0x689cC7BB716AfF448DcA16a8b61253C7E246D9Fc", //TMT
    "0x61Efb60A075479D96Ad3D1C54dd87D71AfFF980f", //Prevail
    "0xC001BBe2B87079294C63EcE98BdD0a88D761434e", //EGC
    "0x237FA37Be83955C62d852B16516e6F4407bf3945",//VIDIAC
    // "0xF59918B07278ff20109f8c37d7255e0677B45c43", //AFNTY
    //"0x988F7c894e4001EEB7B570CDE80dffE21CF7B6B9", //LUCRO
    // "0xdA1Af96c20BCc605d2974973C8632d010B93054C", //BTCE
    // "0xeCbB702c05c79905554F2DEbA04151C3d89Dab00", //BNBE
    // "0x9A3E55a80d449007ED15Dab6ee5B08AF4f644f19", //ChadMcWhale
    "0x27874A586bafaF54d4Cd0aae368ad9569D06d115", //AUSDv2
    "0xA11b53C5ecA5AFcb9eB8e7E60260721c4f398279", //ATRON
    "0x6e61579c22F9a6dA63a33e819f29B6697d2a126E", //RocketFi
    "0xF33893DE6eB6aE9A67442E066aE9aBd228f5290c", //Grove
    "0x350494Bcc94EfB5c6080f6A6F0043da27be2AD2C", //DFSM
    "0x5A341DCF49e161CC73591f02e5f8CDE8A29733fb", //Reflecto
    "0x14220f5893e945EeD36389905b991d6b972e04f0", //STACKS
    "0x4e90fe9d6C26b5DafF55b69a00197b5601cADd68", //USDTREE
    "0xF59918B07278ff20109f8c37d7255e0677B45c43", //AFNTY
    "0x59803e5Fe213D4B22fb9b061c4C89E716a1CA760", //OPHX
    //"0x2e3B6906B976AB8Da82228e0569B3ef6ea1e8Cc6", //AUSD
    "0xd8Fa690304D2B2824D918C0c7376e2823704557A", //SQUIDGROW
    "0xfE642F7463b7A2aB67690209ED5A070a46b66064", //PLAYFI
    "0x0Cab564F58AD72877F0bc3Cd52468860294c15a6", //UltraBNB
    "0x904B4224acA463666E98f21cC8C54f8D423f6648", //UltraBTC
    "0xDfD077c9C2F488e5CFeD14EbBcb7B8E056334EbA", //UltraETH
    "0x3834303483f139c26bc282528aDee6b7Da103D54", //UltraXRP
    "0x09b22c55436cb5F4F91306e632e0a5F0DD031BA8", //UltraSOL
    "0x2a5D78825Bf470e70f9B62F2BCE8483941c11132", //UltraSHIB
    "0xdfBEA88C4842d30c26669602888d746D30F9D60d", //crow with knife
    "0xf82007D28B8D0EaFC6Fde42eCb697A74824D839E", //INTL
];

const DIVIDEND_TOKENS = [
    "0x5097FccD1E58fC18717c6bFc8Ca0E6dc0e006758", //ReflectR
    "0x5d5dC8e4D680FC3eF33986292eB02315ab05c735", //Yin
    "0xC486312D5158315C7Bbe2C353ad565d1A9d1f0de", //Yang
    "0x942e4B2De5BA499181b390daD4CAe8e0A27c606b", //AutoBTC
    "0xa68D77D85b24257adae0bC9Ca96edcBCba5F03Ea", //OBS
    "0x651a89fed302227d41425235F8E934502FB94C48", //ADACash
    "0x7B86f5ca09Dc00502E342b0FeF5117E1c32222Ce", //SolCash
    "0x3C2e501B08CF5C16061468c96b19b32bae451dA3", //EverFlect
    "0x3a91A88Ef4bB813BB99EF5a745bcb56e3A3b403b", //INCOME
    //"0xA7efd5D0575cD4682B0c83155bB9e4Ff1a85a6F9", //LMG
    "0xA341E745078035D6d19E2F2B518DE31f29b2a1bE", //RDFY
    "0x689cC7BB716AfF448DcA16a8b61253C7E246D9Fc", //TMT
    "0x61Efb60A075479D96Ad3D1C54dd87D71AfFF980f", //Prevail
];
const DIVIDEND_TOKENS_TYPE2 = [
    "0xC001BBe2B87079294C63EcE98BdD0a88D761434e",//EGC
    "0x237FA37Be83955C62d852B16516e6F4407bf3945",//VIDIAC
    // "0xF59918B07278ff20109f8c37d7255e0677B45c43",//AFNTY
    //"0x988F7c894e4001EEB7B570CDE80dffE21CF7B6B9", //LUCRO
    // "0xdA1Af96c20BCc605d2974973C8632d010B93054C",//BTCE
    // "0xeCbB702c05c79905554F2DEbA04151C3d89Dab00",//BNBE
];

const DIVIDEND_TOKENS_TYPE3 = [
    // "0x9A3E55a80d449007ED15Dab6ee5B08AF4f644f19",//ChadMcWhale
    "0x27874A586bafaF54d4Cd0aae368ad9569D06d115", //AUSDv2
    "0xA11b53C5ecA5AFcb9eB8e7E60260721c4f398279", //ATRON
    "0x6e61579c22F9a6dA63a33e819f29B6697d2a126E", //RocketFi
    "0xF33893DE6eB6aE9A67442E066aE9aBd228f5290c",//Grove
    "0x350494Bcc94EfB5c6080f6A6F0043da27be2AD2C", //DFSM
    "0x5A341DCF49e161CC73591f02e5f8CDE8A29733fb", //Reflecto
    "0x14220f5893e945EeD36389905b991d6b972e04f0",//STACKS
    "0x4e90fe9d6C26b5DafF55b69a00197b5601cADd68",//USDTREE
    "0xF59918B07278ff20109f8c37d7255e0677B45c43",//AFNTY
    "0x59803e5Fe213D4B22fb9b061c4C89E716a1CA760",//OPHX
    //"0x2e3B6906B976AB8Da82228e0569B3ef6ea1e8Cc6",//AUSD
   
    "0xd8Fa690304D2B2824D918C0c7376e2823704557A", //SQUIDGROW
    "0xfE642F7463b7A2aB67690209ED5A070a46b66064", //PLAYFI
    "0x0Cab564F58AD72877F0bc3Cd52468860294c15a6", //UltraBNB
    "0x904B4224acA463666E98f21cC8C54f8D423f6648", //UltraBTC
    "0xDfD077c9C2F488e5CFeD14EbBcb7B8E056334EbA", //UltraETH
    "0x3834303483f139c26bc282528aDee6b7Da103D54", //UltraXRP
    "0x09b22c55436cb5F4F91306e632e0a5F0DD031BA8", //UltraSOL
    "0x2a5D78825Bf470e70f9B62F2BCE8483941c11132", //UltraSHIB
    "0xdfBEA88C4842d30c26669602888d746D30F9D60d", //crow with knife
    "0xf82007D28B8D0EaFC6Fde42eCb697A74824D839E", //INTL
];

//CONVERT THE COMPONENTS FROM THIS ONE TO THE NEW FORMAT
const DIVIDEND_TOKEN_CONFIG = {
    "Type1": { //BBR Style Distributor
        addresses: [
            "0x5097FccD1E58fC18717c6bFc8Ca0E6dc0e006758", //ReflectR
            "0x5d5dC8e4D680FC3eF33986292eB02315ab05c735", //Yin
            "0xC486312D5158315C7Bbe2C353ad565d1A9d1f0de", //Yang
            "0x942e4B2De5BA499181b390daD4CAe8e0A27c606b", //AutoBTC
            "0xa68D77D85b24257adae0bC9Ca96edcBCba5F03Ea", //OBS
            "0x651a89fed302227d41425235F8E934502FB94C48", //ADACash
            "0x7B86f5ca09Dc00502E342b0FeF5117E1c32222Ce", //SolCash
            "0x3C2e501B08CF5C16061468c96b19b32bae451dA3", //EverFlect
            "0x3a91A88Ef4bB813BB99EF5a745bcb56e3A3b403b", //INCOME
            //"0xA7efd5D0575cD4682B0c83155bB9e4Ff1a85a6F9", //LMG
            "0xA341E745078035D6d19E2F2B518DE31f29b2a1bE", //RDFY
            "0x689cC7BB716AfF448DcA16a8b61253C7E246D9Fc", //TMT,
            "0x61Efb60A075479D96Ad3D1C54dd87D71AfFF980f", //Prevail
        ],
        abi: dividendToken_1_Abi,
        distributorAbi: dividendToken_1_distributorAbi
    },
    "Type2": { //SafeEarn Style Distributor. Loads only the IERC20 token interface. Supplemental distributorABI is provided via getSupplementalAbi function.
        addresses: [
            "0xC001BBe2B87079294C63EcE98BdD0a88D761434e",//EGC
            "0x237FA37Be83955C62d852B16516e6F4407bf3945",//VIDIAC
            // "0xF59918B07278ff20109f8c37d7255e0677B45c43",//AFNTY
            //"0x988F7c894e4001EEB7B570CDE80dffE21CF7B6B9", //LUCRO
            // "0xdA1Af96c20BCc605d2974973C8632d010B93054C",//BTCE
            // "0xeCbB702c05c79905554F2DEbA04151C3d89Dab00",//BNBE
        ],
        abi: distributorToken_1_Abi
    },
    "Type3": {
        addresses: [
            // "0x9A3E55a80d449007ED15Dab6ee5B08AF4f644f19", //ChadMcWhale
            "0x27874A586bafaF54d4Cd0aae368ad9569D06d115", //AUSDv2
            "0xA11b53C5ecA5AFcb9eB8e7E60260721c4f398279", //ATRON
            "0x6e61579c22F9a6dA63a33e819f29B6697d2a126E", //RocketFi
            "0xF33893DE6eB6aE9A67442E066aE9aBd228f5290c",//Grove
            "0x350494Bcc94EfB5c6080f6A6F0043da27be2AD2C", //DFSM
            "0x5A341DCF49e161CC73591f02e5f8CDE8A29733fb", //Reflecto
            "0x14220f5893e945EeD36389905b991d6b972e04f0", //STACKS
            "0x4e90fe9d6C26b5DafF55b69a00197b5601cADd68", //USDTREE
            "0xF59918B07278ff20109f8c37d7255e0677B45c43", //AFNTY
            "0x59803e5Fe213D4B22fb9b061c4C89E716a1CA760", //OPHX
            //"0x2e3B6906B976AB8Da82228e0569B3ef6ea1e8Cc6", //AUSD
            "0xd8Fa690304D2B2824D918C0c7376e2823704557A", //SQUIDGROW
            "0xfE642F7463b7A2aB67690209ED5A070a46b66064", //PLAYFI
            "0x0Cab564F58AD72877F0bc3Cd52468860294c15a6", //UltraBNB
            "0x904B4224acA463666E98f21cC8C54f8D423f6648", //UltraBTC
            "0xDfD077c9C2F488e5CFeD14EbBcb7B8E056334EbA", //UltraETH
            "0x3834303483f139c26bc282528aDee6b7Da103D54", //UltraXRP
            "0x09b22c55436cb5F4F91306e632e0a5F0DD031BA8", //UltraSOL
            "0x2a5D78825Bf470e70f9B62F2BCE8483941c11132", //UltraSHIB
            "0xdfBEA88C4842d30c26669602888d746D30F9D60d", //crow with knife
            "0xf82007D28B8D0EaFC6Fde42eCb697A74824D839E", //INTL
        ],
    },
    // Add more types here as needed.
}

const DISTRIBUTOR_CONFIG = {
    //eBTCE
    "0xdA1Af96c20BCc605d2974973C8632d010B93054C": {
        abi: distributor_1_Abi,
        distributorAddress: "0x8baEf8D4266662F175B616A730c972f85Fc24991",
    },//EverGrow
    "0xC001BBe2B87079294C63EcE98BdD0a88D761434e": {
        abi: distributor_1_Abi,
        distributorAddress: "0xfbAb1D829e36EFbD13642229EAe2964004f38C41",
    },//LUCRO
    "0x988F7c894e4001EEB7B570CDE80dffE21CF7B6B9": {
        abi: distributor_1_Abi,
        distributorAddress: "0xDC88c8c2421f46ACE2b6Cfc437FfD4c0E3a061A6",
    },//eBNBE
    "0xeCbB702c05c79905554F2DEbA04151C3d89Dab00": {
        abi: distributor_1_Abi,
        distributorAddress: "0x9598868452bF570E8d1df5b2D2461de57C2918CD",
    },//AFNTY
    // "0xF59918B07278ff20109f8c37d7255e0677B45c43": {
    //     abi: distributor_1_Abi,
    //     distributorAddress: "0x4a8947f2FFaEBf119DFA2035A5Ed59d347Eb3E21",
    // },//VIDIAC
    "0x237FA37Be83955C62d852B16516e6F4407bf3945": {
        abi: distributor_1_Abi,
        distributorAddress: "0xE38C4daD81C4157992FdA4BE606bfbC0543F1e26",
    },
}



// const DIVIDEND_TOKEN_CONFIG = {
//     "Type1": { //BBR Style Distributor
//         addresses: [ 
//             {"0x5097FccD1E58fC18717c6bFc8Ca0E6dc0e006758":dividendToken_2_Abi}, //ReflectR
//             {"0x5d5dC8e4D680FC3eF33986292eB02315ab05c735":dividendToken_1_Abi}, //Yin
//             {"0xC486312D5158315C7Bbe2C353ad565d1A9d1f0de":dividendToken_1_Abi}, //Yang
//             {"0xa68D77D85b24257adae0bC9Ca96edcBCba5F03Ea":dividendToken_1_Abi}, //ODS
//         ],
//         distributorAbi: dividendToken_1_distributorAbi
//     },
//     "Type2": { //SafeEarn Style Distributor. Loads only the IERC20 token interface. Supplemental distributorABI is provided via getSupplementalAbi function.
//         addresses: [
//             {"0xdA1Af96c20BCc605d2974973C8632d010B93054C":distributorToken_1_Abi},
//             {"0xC001BBe2B87079294C63EcE98BdD0a88D761434e":distributorToken_1_Abi},
//             //"0x988F7c894e4001EEB7B570CDE80dffE21CF7B6B9",
//             {"0xeCbB702c05c79905554F2DEbA04151C3d89Dab00":distributorToken_1_Abi},
//         ],
//     },
//     // Add more types here as needed.
// }






// DefiApp Service

export const DefiAppService = {

    getDappProperties: (defiApp) => {
        if (defiApp === "RocketFi") {
            return {
                enableIconColor: true,

                disconnectedToggleBackground: '#323232',
                disconnectedTextColor: '#FFE37B',
                disconnectedText: 'Tap To Connect',
                disconnectedNotchColor: '#FFE37B',
                disconnectedIcon: disconnectIcon,
                disconnectedColor: '#323232',


                connectingToggleBackground: '#493930',
                connectingTextColor: '#FFAB7B',
                connectingText: 'Connecting...',
                connectingNotchColor: '#FFAB7B',
                connectingIcon: connectingIcon,
                connectingIconColor: '#493930',

                connectedToggleBackground: '#193E35',
                connectedTextColor: '#7BFFD7',
                connectedText: 'Connected!',
                connectedNotchColor: '#7BFFD7',
                connectedIcon1: connectedIcon,
                connectedIconColor: '#193E35',
                connectedIcon2: rocketfiIcon,

                appMenuActive: appMenuActive,
                appMenuStandby: appMenuStandby,
                appMenuPressed: appMenuPressed,

            }
        } else if (defiApp === "Floatie") {
            return {
                enableIconColor: false,

                disconnectedToggleBackground: '#FFFFFF',
                disconnectedTextColor: '#EC599A',
                disconnectedText: 'Press To Connect',
                disconnectedNotchColor: '#FFE2EF',
                disconnectedIcon: floatieDisconnectIcon,
                disconnectedIconColor: '',


                connectingToggleBackground: '#C8E5FF',
                connectingTextColor: '#00427B',
                connectingText: 'Loading...',
                connectingNotchColor: '#FFFFFF',
                connectingIcon: floatieConnectingIcon,
                connectingIconColor: '',

                connectedToggleBackground: '#AFD9FF',
                connectedTextColor: '#00427B',
                connectedText: 'Welcome!',
                connectedNotchColor: '#FFFFFF',
                connectedIcon1: floatieConnectedIcon,
                connectedIconColor: '',
                connectedIcon2: floatieIcon,

                appMenuActive: appMenuActive_floatie,
                appMenuStandby: appMenuStandby_floatie,
                appMenuPressed: appMenuPressed_floatie,
            }

        } else if (defiApp === "Ultra") {
            return {
                enableIconColor: true,

                disconnectedToggleBackground: '#32A1CB',
                disconnectedTextColor: '#FFFFFF',
                disconnectedText: 'Tap To Connect',
                disconnectedNotchColor: '#65CEF6',
                disconnectedIcon: ultraDisconnectIcon,
                disconnectedColor: '#32A1CB',


                connectingToggleBackground: '#32A1CB',
                connectingTextColor: '#FFFFFF',
                connectingText: 'Connecting...',
                connectingNotchColor: '#65CEF6',
                connectingIcon: ultraConnectingIcon,
                connectingIconColor: '#493930',

                connectedToggleBackground: '#32A1CB',
                connectedTextColor: '#FFFFFF',
                connectedText: 'Connected!',
                connectedNotchColor: '#65CEF6',
                connectedIcon1: ultraConnectedIcon,
                connectedIconColor: '#32A1CB',
                connectedIcon2: ultraIcon,

                appMenuActive: appMenuActive_ultra,
                appMenuStandby: appMenuStandby_ultra,
                appMenuPressed: appMenuPressed_ultra,
            }

        } else if (defiApp === "Radar") {
            return {
                enableIconColor: true,

                disconnectedToggleBackground: '#323232',
                disconnectedTextColor: '#FFE37B',
                disconnectedText: 'Tap To Connect',
                disconnectedNotchColor: '#FFE37B',
                disconnectedIcon: disconnectIcon,
                disconnectedColor: '#323232',


                connectingToggleBackground: '#493930',
                connectingTextColor: '#FFAB7B',
                connectingText: 'Connecting...',
                connectingNotchColor: '#FFAB7B',
                connectingIcon: connectingIcon,
                connectingIconColor: '#493930',

                connectedToggleBackground: '#192a3e',
                connectedTextColor: '#d1e7ff',
                connectedText: 'Connected!',
                connectedNotchColor: '#d1e7ff',
                connectedIcon1: connectedIcon,
                connectedIconColor: '#192a3e',
                connectedIcon2: radarIcon,

                appMenuActive: appMenuActive_floatie,
                appMenuStandby: appMenuStandby_floatie,
                appMenuPressed: appMenuPressed_floatie,

            }
        } else if (defiApp === "Refuel") {
            return {
                enableIconColor: true,

                disconnectedToggleBackground: '#323232',
                disconnectedTextColor: '#FFE37B',
                disconnectedText: 'Tap To Connect',
                disconnectedNotchColor: '#FFE37B',
                disconnectedIcon: disconnectIcon,
                disconnectedColor: '#323232',


                connectingToggleBackground: '#493930',
                connectingTextColor: '#FFAB7B',
                connectingText: 'Connecting...',
                connectingNotchColor: '#FFAB7B',
                connectingIcon: connectingIcon,
                connectingIconColor: '#493930',

                connectedToggleBackground: '#a32100',
                connectedTextColor: '#FFAA5B',
                connectedText: 'Connected!',
                connectedNotchColor: '#FFAA5B',
                connectedIcon1: connectedIcon_refuel,
                connectedIconColor: '#193E35',
                connectedIcon2: refuelIcon,

                appMenuActive: appMenuActive_refuel,
                appMenuStandby: appMenuStandby_refuel,
                appMenuPressed: appMenuPressed_refuel,

            }
        }
    },

    getTokenTypeByAddress: (address) => {
        for (let type in DIVIDEND_TOKEN_CONFIG) {
            if (DIVIDEND_TOKEN_CONFIG[type].addresses.includes(address)) {
                return type;
            }
        }
        return null; // or throw an error
    },

    getAbiByTokenType: (tokenType) => {
        return DIVIDEND_TOKEN_CONFIG[tokenType];
    },

    getDistributorAbiByTokenType: (tokenType) => {
        return DIVIDEND_TOKEN_CONFIG[tokenType].distributorAbi;
    },


    getDappContracts: (defiApp) => {
        if (defiApp === "RocketFi") {
            return {
                rp_rocketFiFeeRouter: { address: RP_ROCKETFI_FEE_ROUTER_CONTRACT_ADDRESS, abi: rocketFiFeeRouterAbi },
                rp_resyncShares: { address: RP_RESYNC_SHARES_CONTRACT_ADDRESS, abi: resyncSharesAbi },
                rp_rewardPacks: { address: RP_REWARD_PACKS_CONTRACT_ADDRESS, abi: rewardPacksAbi },
                rp_rewardPacksOracle: { address: RP_REWARD_PACKS_ORACLE_CONTRACT_ADDRESS, abi: rewardPackOracleAbi },
                rp_rewardPackManager: { address: RP_REWARD_PACK_MANAGER_CONTRACT_ADDRESS, abi: rewardPackManagerAbi },
                smartRewards: { address: SMART_REWARDS_CONTRACT_ADDRESS, abi: smartRewardsAbi },
                smartRewardsV2: { address: SMART_REWARDS_V2_CONTRACT_ADDRESS, abi: smartRewards_V2_Gateway_Abi },
                smartRewardsV1: { address: SMART_REWARDS_V1_CONTRACT_ADDRESS, abi: smartRewards_V2_Gateway_Abi },
                rocketFiOracle: { address: ROCKETFI_ORACLE_CONTRACT_ADDRESS, abi: rocketFiOracleAbi },
                rp_rocketFiOracle: { address: RP_ROCKETFI_ORACLE_CONTRACT_ADDRESS, abi: rocketFiOracleAbi },
                liquidityOracle: { address: LIQUIDITY_ORACLE_CONTRACT_ADDRESS, abi: liquidityOracleAbi },
                liquidityOraclePaginator: { address: LIQUIDITY_ORACLE_PAGINATOR_CONTRACT_ADDRESS, abi: liquidityOraclePaginatorAbi },
                rocketFuel: { address: ROCKET_FUEL_CONTRACT_ADDRESS, abi: rocketFuelAbi },
                rocketFiOracleV2: { address: ROCKETFI_ORACLE_V2_CONTRACT_ADDRESS, abi: rocketFiOracleAbi },
                rocketFiOracleV1: { address: ROCKETFI_ORACLE_V1_CONTRACT_ADDRESS, abi: rocketFiOracleAbi },
                rocketFi: { address: ROCKETFI_CONTRACT_ADDRESS, abi: rocketFiAbi },
                burnToEarnResync: { address: BURN_TO_EARN_RESYNC_CONTRACT_ADDRESS, abi: burnToEarnResyncAbi },
                payItForward: { address: PAY_IT_FORWARD_CONTRACT_ADDRESS, abi: payItForwardAbi },
                rocketSwapper: { address: ROCKET_SWAPPER_CONTRACT_ADDRESS, abi: rocketSwapperAbi },
                rocketSwapperLegacy: { address: ROCKET_SWAPPER_LEGACY_CONTRACT_ADDRESS, abi: rocketSwapperLegacyAbi },
                smartCodesV1: { address: SMART_CODES_V1_CONTRACT_ADDRESS, abi: smartCodesAbi },
                smartCodes: { address: SMART_CODES_CONTRACT_ADDRESS, abi: smartCodesAbi },
                smartCodePositionOracle: { address: SMART_CODES_POSITION_ORACLE_CONTRACT_ADDRESS, abi: smartCodePositionOracleAbi },
                smartCodeRewardShareSyncer: { address: SMART_CODES_REWARD_SHARE_SYNCER_CONTRACT_ADDRESS, abi: smartCodeRewardShareSyncerAbi },
                rocketFiRewards: { address: ROCKETFI_REWARDS_CONTRACT_ADDRESS, abi: rocketFiRewardsAbi },
                loyaltyEngine: { address: LOYALTY_ENGINE_CONTRACT_ADDRESS, abi: loyaltyEngineAbi },
                earningsTrackerV1: { address: EARNINGS_TRACKER_V1_CONTRACT_ADDRESS, abi: earningsTracker_V1_Abi },
                earningsTracker: { address: EARNINGS_TRACKER_CONTRACT_ADDRESS, abi: earningsTrackerAbi },
                rocketPlay: { address: ROCKETPLAY_CONTRACT_ADDRESS, abi: rocketPlayAbi },
            }
        } else if (defiApp === "Floatie") {
            return {
                rp_rocketFiFeeRouter: { address: RP_ROCKETFI_FEE_ROUTER_CONTRACT_ADDRESS, abi: rocketFiFeeRouterAbi },
                rp_resyncShares: { address: RP_RESYNC_SHARES_CONTRACT_ADDRESS, abi: resyncSharesAbi },
                rp_rewardPacks: { address: RP_REWARD_PACKS_CONTRACT_ADDRESS, abi: rewardPacksAbi },
                rp_rewardPacksOracle: { address: RP_REWARD_PACKS_ORACLE_CONTRACT_ADDRESS, abi: rewardPackOracleAbi },
                rp_rewardPackManager: { address: RP_REWARD_PACK_MANAGER_CONTRACT_ADDRESS, abi: rewardPackManagerAbi },
                smartRewards: { address: SMART_REWARDS_CONTRACT_ADDRESS, abi: smartRewardsAbi },
                smartRewardsV2: { address: SMART_REWARDS_V2_CONTRACT_ADDRESS, abi: smartRewards_V2_Gateway_Abi },
                smartRewardsV1: { address: SMART_REWARDS_V1_CONTRACT_ADDRESS, abi: smartRewards_V2_Gateway_Abi },
                rocketFiOracle: { address: ROCKETFI_ORACLE_CONTRACT_ADDRESS, abi: rocketFiOracleAbi },
                rp_rocketFiOracle: { address: RP_ROCKETFI_ORACLE_CONTRACT_ADDRESS, abi: rocketFiOracleAbi },
                liquidityOracle: { address: LIQUIDITY_ORACLE_CONTRACT_ADDRESS, abi: liquidityOracleAbi },
                liquidityOraclePaginator: { address: LIQUIDITY_ORACLE_PAGINATOR_CONTRACT_ADDRESS, abi: liquidityOraclePaginatorAbi },
                rocketFuel: { address: ROCKET_FUEL_CONTRACT_ADDRESS, abi: rocketFuelAbi },
                rocketFiOracleV2: { address: ROCKETFI_ORACLE_V2_CONTRACT_ADDRESS, abi: rocketFiOracleAbi },
                rocketFiOracleV1: { address: ROCKETFI_ORACLE_V1_CONTRACT_ADDRESS, abi: rocketFiOracleAbi },
                rocketFi: { address: ROCKETFI_CONTRACT_ADDRESS, abi: rocketFiAbi },
                burnToEarnResync: { address: BURN_TO_EARN_RESYNC_CONTRACT_ADDRESS, abi: burnToEarnResyncAbi },
                payItForward: { address: PAY_IT_FORWARD_CONTRACT_ADDRESS, abi: payItForwardAbi },
                rocketSwapper: { address: ROCKET_SWAPPER_CONTRACT_ADDRESS, abi: rocketSwapperAbi },
                rocketSwapperLegacy: { address: ROCKET_SWAPPER_LEGACY_CONTRACT_ADDRESS, abi: rocketSwapperLegacyAbi },
                smartCodesV1: { address: SMART_CODES_V1_CONTRACT_ADDRESS, abi: smartCodesAbi },
                smartCodes: { address: SMART_CODES_CONTRACT_ADDRESS, abi: smartCodesAbi },
                smartCodePositionOracle: { address: SMART_CODES_POSITION_ORACLE_CONTRACT_ADDRESS, abi: smartCodePositionOracleAbi },
                smartCodeRewardShareSyncer: { address: SMART_CODES_REWARD_SHARE_SYNCER_CONTRACT_ADDRESS, abi: smartCodeRewardShareSyncerAbi },
                rocketFiRewards: { address: ROCKETFI_REWARDS_CONTRACT_ADDRESS, abi: rocketFiRewardsAbi },
                loyaltyEngine: { address: LOYALTY_ENGINE_CONTRACT_ADDRESS, abi: loyaltyEngineAbi },
                earningsTrackerV1: { address: EARNINGS_TRACKER_V1_CONTRACT_ADDRESS, abi: earningsTracker_V1_Abi },
                earningsTracker: { address: EARNINGS_TRACKER_CONTRACT_ADDRESS, abi: earningsTrackerAbi },
                rocketPlay: { address: ROCKETPLAY_CONTRACT_ADDRESS, abi: rocketPlayAbi },
                ultraDistributor: { address: ULTRA_DISTRIBUTOR_CONTRACT_ADDRESS, abi: ultraDistributorAbi },
                ausd: { address: AUSD_CONTRACT_ADDRESS, abi: ausdAbi },
                atron: { address: ATRON_CONTRACT_ADDRESS, abi: atronAbi },

                lockerBay: { address: LOCKERBAY_CONTRACT_ADDRESS, abi: lockerBayAbi },
                votingProposal: { address: VOTING_PROPOSAL_CONTRACT_ADDRESS, abi: votingProposalAbi },
                floatieGateway: { address: FLOATIE_GATEWAY_CONTRACT_ADDRESS, abi: floatieGatewayAbi },
                floatieGatewayOracle: { address: FLOATIE_GATEWAY_ORACLE_CONTRACT_ADDRESS, abi: floatieGatewayOracleAbi },
                floatieBurn: { address: FLOATIE_BURN_CONTRACT_ADDRESS, abi: floatieBurnAbi },
                floatieEarn: { address: FLOATIE_EARN_CONTRACT_ADDRESS, abi: floatieEarnAbi },
                floatiePlay: { address: FLOATIE_PLAY_CONTRACT_ADDRESS, abi: floatiePlayAbi },
                floatieStake: { address: FLOATIE_STAKE_CONTRACT_ADDRESS, abi: floatieStakeAbi },
            }
        } else if (defiApp === "Ultra") {
            return {
                rocketSwapperLegacy: { address: ROCKET_SWAPPER_LEGACY_CONTRACT_ADDRESS, abi: rocketSwapperLegacyAbi },
                rocketPlay: { address: ROCKETPLAY_CONTRACT_ADDRESS, abi: rocketPlayAbi },
                feeHook: { address: FEEHOOK_CONTRACT_ADDRESS, abi: feeHookAbi },
                ultraDistributor: { address: ULTRA_DISTRIBUTOR_CONTRACT_ADDRESS, abi: ultraDistributorAbi },
                liquidityOracle: { address: LIQUIDITY_ORACLE_CONTRACT_ADDRESS, abi: liquidityOracleAbi },
                liquidityOraclePaginator: { address: LIQUIDITY_ORACLE_PAGINATOR_CONTRACT_ADDRESS, abi: liquidityOraclePaginatorAbi },
            }
        } else if (defiApp === "Radar") {
            let contracts = {
                rp_rocketFiFeeRouter: { address: RP_ROCKETFI_FEE_ROUTER_CONTRACT_ADDRESS, abi: rocketFiFeeRouterAbi },
                rp_resyncShares: { address: RP_RESYNC_SHARES_CONTRACT_ADDRESS, abi: resyncSharesAbi },
                rp_rewardPacks: { address: RP_REWARD_PACKS_CONTRACT_ADDRESS, abi: rewardPacksAbi },
                rp_rewardPacksOracle: { address: RP_REWARD_PACKS_ORACLE_CONTRACT_ADDRESS, abi: rewardPackOracleAbi },
                rp_rewardPackManager: { address: RP_REWARD_PACK_MANAGER_CONTRACT_ADDRESS, abi: rewardPackManagerAbi },
                smartRewards: { address: SMART_REWARDS_CONTRACT_ADDRESS, abi: smartRewardsAbi },
                smartRewardsV2: { address: SMART_REWARDS_V2_CONTRACT_ADDRESS, abi: smartRewards_V2_Gateway_Abi },
                smartRewardsV1: { address: SMART_REWARDS_V1_CONTRACT_ADDRESS, abi: smartRewards_V2_Gateway_Abi },
                rocketFiOracle: { address: ROCKETFI_ORACLE_CONTRACT_ADDRESS, abi: rocketFiOracleAbi },
                rp_rocketFiOracle: { address: RP_ROCKETFI_ORACLE_CONTRACT_ADDRESS, abi: rocketFiOracleAbi },
                liquidityOracle: { address: LIQUIDITY_ORACLE_CONTRACT_ADDRESS, abi: liquidityOracleAbi },
                liquidityOraclePaginator: { address: LIQUIDITY_ORACLE_PAGINATOR_CONTRACT_ADDRESS, abi: liquidityOraclePaginatorAbi },
                rocketFuel: { address: ROCKET_FUEL_CONTRACT_ADDRESS, abi: rocketFuelAbi },
                rocketFiOracleV2: { address: ROCKETFI_ORACLE_V2_CONTRACT_ADDRESS, abi: rocketFiOracleAbi },
                rocketFiOracleV1: { address: ROCKETFI_ORACLE_V1_CONTRACT_ADDRESS, abi: rocketFiOracleAbi },
                rocketFi: { address: ROCKETFI_CONTRACT_ADDRESS, abi: rocketFiAbi },
                burnToEarnResync: { address: BURN_TO_EARN_RESYNC_CONTRACT_ADDRESS, abi: burnToEarnResyncAbi },
                payItForward: { address: PAY_IT_FORWARD_CONTRACT_ADDRESS, abi: payItForwardAbi },
                rocketSwapper: { address: ROCKET_SWAPPER_CONTRACT_ADDRESS, abi: rocketSwapperAbi },
                rocketSwapperLegacy: { address: ROCKET_SWAPPER_LEGACY_CONTRACT_ADDRESS, abi: rocketSwapperLegacyAbi },
                smartCodesV1: { address: SMART_CODES_V1_CONTRACT_ADDRESS, abi: smartCodesAbi },
                smartCodes: { address: SMART_CODES_CONTRACT_ADDRESS, abi: smartCodesAbi },
                smartCodePositionOracle: { address: SMART_CODES_POSITION_ORACLE_CONTRACT_ADDRESS, abi: smartCodePositionOracleAbi },
                smartCodeRewardShareSyncer: { address: SMART_CODES_REWARD_SHARE_SYNCER_CONTRACT_ADDRESS, abi: smartCodeRewardShareSyncerAbi },
                rocketFiRewards: { address: ROCKETFI_REWARDS_CONTRACT_ADDRESS, abi: rocketFiRewardsAbi },
                loyaltyEngine: { address: LOYALTY_ENGINE_CONTRACT_ADDRESS, abi: loyaltyEngineAbi },
                earningsTrackerV1: { address: EARNINGS_TRACKER_V1_CONTRACT_ADDRESS, abi: earningsTracker_V1_Abi },
                earningsTracker: { address: EARNINGS_TRACKER_CONTRACT_ADDRESS, abi: earningsTrackerAbi },
                rocketPlay: { address: ROCKETPLAY_CONTRACT_ADDRESS, abi: rocketPlayAbi },
                ultraDistributor: { address: ULTRA_DISTRIBUTOR_CONTRACT_ADDRESS, abi: ultraDistributorAbi },
                ausd: { address: AUSD_CONTRACT_ADDRESS, abi: ausdAbi },
                atron: { address: ATRON_CONTRACT_ADDRESS, abi: atronAbi },
                reflectr: { address: REFLECTR_CONTRACT_ADDRESS, abi: reflectrAbi },
                yin: { address: YIN_CONTRACT_ADDRESS, abi: dividendToken_1_Abi },
                yang: { address: YANG_CONTRACT_ADDRESS, abi: dividendToken_1_Abi },
                lpSeeder: { address: LP_SEEDER_CONTRACT_ADDRESS, abi: lpSeederAbi },

                lockerBay: { address: LOCKERBAY_CONTRACT_ADDRESS, abi: lockerBayAbi },
                votingProposal: { address: VOTING_PROPOSAL_CONTRACT_ADDRESS, abi: votingProposalAbi },
                floatieGateway: { address: FLOATIE_GATEWAY_CONTRACT_ADDRESS, abi: floatieGatewayAbi },
                floatieGatewayOracle: { address: FLOATIE_GATEWAY_ORACLE_CONTRACT_ADDRESS, abi: floatieGatewayOracleAbi },
                floatieBurn: { address: FLOATIE_BURN_CONTRACT_ADDRESS, abi: floatieBurnAbi },
                floatieEarn: { address: FLOATIE_EARN_CONTRACT_ADDRESS, abi: floatieEarnAbi },
                floatiePlay: { address: FLOATIE_PLAY_CONTRACT_ADDRESS, abi: floatiePlayAbi },
                floatieStake: { address: FLOATIE_STAKE_CONTRACT_ADDRESS, abi: floatieStakeAbi }
        }

        return contracts;
    } else if (defiApp === "Refuel") {
            return {
                rp_rocketFiFeeRouter: { address: RP_ROCKETFI_FEE_ROUTER_CONTRACT_ADDRESS, abi: rocketFiFeeRouterAbi },
                rp_resyncShares: { address: RP_RESYNC_SHARES_CONTRACT_ADDRESS, abi: resyncSharesAbi },
                rp_rewardPacks: { address: RP_REWARD_PACKS_CONTRACT_ADDRESS, abi: rewardPacksAbi },
                rp_rewardPacksOracle: { address: RP_REWARD_PACKS_ORACLE_CONTRACT_ADDRESS, abi: rewardPackOracleAbi },
                rp_rewardPackManager: { address: RP_REWARD_PACK_MANAGER_CONTRACT_ADDRESS, abi: rewardPackManagerAbi },
                smartRewards: { address: SMART_REWARDS_CONTRACT_ADDRESS, abi: smartRewardsAbi },
                smartRewardsV2: { address: SMART_REWARDS_V2_CONTRACT_ADDRESS, abi: smartRewards_V2_Gateway_Abi },
                smartRewardsV1: { address: SMART_REWARDS_V1_CONTRACT_ADDRESS, abi: smartRewards_V2_Gateway_Abi },
                rocketFiOracle: { address: ROCKETFI_ORACLE_CONTRACT_ADDRESS, abi: rocketFiOracleAbi },
                rp_rocketFiOracle: { address: RP_ROCKETFI_ORACLE_CONTRACT_ADDRESS, abi: rocketFiOracleAbi },
                liquidityOracle: { address: LIQUIDITY_ORACLE_CONTRACT_ADDRESS, abi: liquidityOracleAbi },
                liquidityOraclePaginator: { address: LIQUIDITY_ORACLE_PAGINATOR_CONTRACT_ADDRESS, abi: liquidityOraclePaginatorAbi },
                rocketFuel: { address: ROCKET_FUEL_CONTRACT_ADDRESS, abi: rocketFuelAbi },
                rocketFiOracleV2: { address: ROCKETFI_ORACLE_V2_CONTRACT_ADDRESS, abi: rocketFiOracleAbi },
                rocketFiOracleV1: { address: ROCKETFI_ORACLE_V1_CONTRACT_ADDRESS, abi: rocketFiOracleAbi },
                rocketFi: { address: ROCKETFI_CONTRACT_ADDRESS, abi: rocketFiAbi },
                burnToEarnResync: { address: BURN_TO_EARN_RESYNC_CONTRACT_ADDRESS, abi: burnToEarnResyncAbi },
                payItForward: { address: PAY_IT_FORWARD_CONTRACT_ADDRESS, abi: payItForwardAbi },
                rocketSwapper: { address: ROCKET_SWAPPER_CONTRACT_ADDRESS, abi: rocketSwapperAbi },
                rocketSwapperLegacy: { address: ROCKET_SWAPPER_LEGACY_CONTRACT_ADDRESS, abi: rocketSwapperLegacyAbi },
                smartCodesV1: { address: SMART_CODES_V1_CONTRACT_ADDRESS, abi: smartCodesAbi },
                smartCodes: { address: SMART_CODES_CONTRACT_ADDRESS, abi: smartCodesAbi },
                smartCodePositionOracle: { address: SMART_CODES_POSITION_ORACLE_CONTRACT_ADDRESS, abi: smartCodePositionOracleAbi },
                smartCodeRewardShareSyncer: { address: SMART_CODES_REWARD_SHARE_SYNCER_CONTRACT_ADDRESS, abi: smartCodeRewardShareSyncerAbi },
                rocketFiRewards: { address: ROCKETFI_REWARDS_CONTRACT_ADDRESS, abi: rocketFiRewardsAbi },
                loyaltyEngine: { address: LOYALTY_ENGINE_CONTRACT_ADDRESS, abi: loyaltyEngineAbi },
                earningsTracker: { address: EARNINGS_TRACKER_CONTRACT_ADDRESS, abi: earningsTrackerAbi },
                refuelDepositer: { address: REFUEL_DEPOSITER_CONTRACT_ADDRESS, abi: refuelDepositerAbi },
                refuelRewards: { address: REFUEL_REWARDS_CONTRACT_ADDRESS, abi: refuelRewardsAbi },
            }
        }
    },

    //DEV NOTE: need to merge getSupplementalContracts and getSupplementalData and getSupplementalAbi and updated everywhere.

    getSupplementalContracts: (defiApp, selectedToken) => {
        if (defiApp === "RocketFi") {
            return LEGACY_CONFIG[selectedToken];
        }
        else if (defiApp === "Floatie") {
            return {

            }
        }
        else if (defiApp === "Radar") {
            return DISTRIBUTOR_CONFIG[selectedToken];

        };
    },

    getDappSupplementalData: (defiApp) => {
        if (defiApp === "RocketFi") {
            return {

            }
        }
        else if (defiApp === "Floatie") {
            return {

            }
        }
        else if (defiApp === "Radar") {
            return ALL_TOKENS
        };
    },

    getSupplementalAbi: (defiApp) => {
        if (defiApp === "RocketFi") {
            return {

            }
        }
        else if (defiApp === "Floatie") {
            return {

            }
        }
        else if (defiApp === "Radar") {
            return dividendToken_1_Abi
        }
        else if (defiApp === "Refuel") {
            return ierc20Abi
        };
    },


    getDefaultToken: (defiApp) => {
        if (defiApp === "RocketFi") {
            return {

            }

        }
        else if (defiApp === "Floatie") {
            return {

            }
        }
        else if (defiApp === "Radar") {
            return "0x8B6bF63e2b1C221dC0Fb01AE85868b83dDee1B54"
        };
    }
}



// else if (defiApp === "Radar") {
//     let contracts = {
//         //smartRewards: { address: SMART_REWARDS_CONTRACT_ADDRESS, abi: smartRewardsAbi },
//         rocketFi: { address: ROCKETFI_CONTRACT_ADDRESS, abi: rocketFiAbi },
//         rp_rewardPacks: { address: RP_REWARD_PACKS_CONTRACT_ADDRESS, abi: rewardPacksAbi },
//         liquidityOracle: { address: LIQUIDITY_ORACLE_CONTRACT_ADDRESS, abi: liquidityOracleAbi },
//         liquidityOracle2: { address: LIQUIDITY_ORACLE_CONTRACT_ADDRESS, abi: liquidityOracleAbi2 },
//         yin: { address: YIN_CONTRACT_ADDRESS, abi: yinyangAbi },
//         yang: { address: YANG_CONTRACT_ADDRESS, abi: yinyangAbi },
//         reflectr: { address: REFLECTR_CONTRACT_ADDRESS, abi: reflectrAbi },
//         ultraDistributor: { address: ULTRA_DISTRIBUTOR_CONTRACT_ADDRESS, abi: ultraDistributorAbi },
//         ausd: { address: AUSD_CONTRACT_ADDRESS, abi: ausdAbi },
//         atron: { address: ATRON_CONTRACT_ADDRESS, abi: atronAbi },
//         liquidityPricingCalculator: { address: LIQUIDITY_PRICING_CALCULATOR_CONTRACT_ADDRESS, abi: liquidityPricingCalculatorAbi },
//     };

//     // DIVIDEND_TOKENS.forEach((dividendTokenAddress, index) => {
//     //     contracts[`dividendToken${index + 1}`] = { address: dividendTokenAddress, abi: dividendToken_1_Abi };
//     // });
//     DIVIDEND_TOKENS.forEach((dividendTokenAddress, index) => {
//         if (dividendTokenAddress === REFLECTR_CONTRACT_ADDRESS) {
//             contracts[`dividendToken${index + 1}`] = { address: dividendTokenAddress, abi: dividendToken_2_Abi };
//         } else {
//             contracts[`dividendToken${index + 1}`] = { address: dividendTokenAddress, abi: dividendToken_1_Abi };
//         }
//     });

//     DIVIDEND_TOKENS_TYPE2.forEach((dividendTokenAddress, index) => {
//         contracts[`dividendToken${index + 1 + DIVIDEND_TOKENS.length}`] = { address: dividendTokenAddress, abi: distributorToken_1_Abi };


//     });

//     DIVIDEND_TOKENS_TYPE3.forEach((dividendTokenAddress, index) => {
//         contracts['dividendToken' + (index + 1 + DIVIDEND_TOKENS.length + DIVIDEND_TOKENS_TYPE2.length)] = { address: dividendTokenAddress, abi: ierc20Abi };
//     });

//     return contracts;
// } else if (defiApp === "Refuel") {